export default __webpack_public_path__ + "static/media/kids_tech.b3d2a784.jpg";